export default function CategoryFilter({ categories, active, onSelect }) {
  return (
    <div className="categories">
      {categories.map((cat) => (
        <button
          key={cat.value}
          className={`cat-btn${active === cat.value ? " active" : ""}`}
          onClick={() => onSelect(cat.value)}
        >
          {cat.label}
        </button>
      ))}
    </div>
  );
}
